import { jsx } from 'react/jsx-runtime';
import { Spinner } from '../Spinner/Spinner.js';
import { BubbleEmployeeLoader } from './BubbleEmployeeLoader.js';
import { ChartLoader } from './ChartLoader.js';
import { DashboardLoader } from './DashboardLoader.js';
import { FormLoader } from './FormLoader.js';

function Loader() {
  return jsx(Spinner, {});
}
Loader.BubbleEmployee = BubbleEmployeeLoader;
Loader.Chart = ChartLoader;
Loader.Dashboard = DashboardLoader;
Loader.Form = FormLoader;

export { Loader };
